var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from "react";
import { usePagination } from "./hooks/usePagination";
import { PaginationItem } from "./PaginationItem";
const defaultProps = {
    as: "div",
    page: 1,
    pageSize: 10,
    getItemAriaLabel: (type, page) => {
        return type === "page" ? `Page ${String(page)}` : type;
    },
    renderItem: (item) => {
        return _jsx(PaginationItem, Object.assign({}, item));
    },
};
export const Pagination = (_a) => {
    var { as: Tag = defaultProps.as, count, page = defaultProps.page, pageSize = defaultProps.pageSize, siblingCount, hideNextButton, hidePrevButton, showFirstButton, showLastButton, onChange, className, itemLabels, getItemAriaLabel = defaultProps.getItemAriaLabel, renderItem = defaultProps.renderItem } = _a, props = __rest(_a, ["as", "count", "page", "pageSize", "siblingCount", "hideNextButton", "hidePrevButton", "showFirstButton", "showLastButton", "onChange", "className", "itemLabels", "getItemAriaLabel", "renderItem"]);
    const { pagesWithEllipsis: pages } = usePagination(page, count, siblingCount);
    const defaultItemLabels = {
        previous: "<",
        next: ">",
        first: "<<",
        last: ">>",
        ellipsis: "...",
        page: (page) => String(page),
    };
    const getItemProps = (type, page, active) => {
        var _a;
        let label = (_a = itemLabels === null || itemLabels === void 0 ? void 0 : itemLabels[type]) !== null && _a !== void 0 ? _a : defaultItemLabels[type];
        label = typeof label === "function" ? label(page) : label;
        return {
            type,
            label,
            "aria-label": getItemAriaLabel(type, page),
            "aria-current": active ? "true" : "false",
        };
    };
    return (_jsx(_Fragment, { children: pages.length > 1 ? (_jsxs(Tag, Object.assign({ className: `pages ${className !== null && className !== void 0 ? className : ""}`.trim() }, props, { children: [showFirstButton &&
                    renderItem(Object.assign(Object.assign({}, getItemProps("first")), { onClick: () => onChange(1), disabled: page === 1 })), !hidePrevButton &&
                    renderItem(Object.assign(Object.assign({}, getItemProps("previous")), { onClick: () => onChange(page - 1), disabled: page === 1 })), pages.map((pageLabel, index) => {
                    return (_jsx(Fragment, { children: typeof pageLabel === "string"
                            ? renderItem(Object.assign({}, getItemProps("ellipsis")))
                            : renderItem(Object.assign(Object.assign({}, getItemProps("page", pageLabel)), { active: page === pageLabel, onClick: () => onChange(pageLabel) })) }, index));
                }), !hideNextButton &&
                    renderItem(Object.assign(Object.assign({}, getItemProps("next")), { onClick: () => onChange(page + 1), disabled: page === count })), showLastButton &&
                    renderItem(Object.assign(Object.assign({}, getItemProps("last")), { onClick: () => onChange(count), disabled: page === count }))] }))) : null }));
};
